import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { buttonVariants } from '@/components/ui/Button'
import { cn } from '@/lib/cn'

export interface CtaBannerProps {
  title: string
  description: string
  ctaText: string
  ctaHref: string
  surface?: '0' | '1' | '2' | undefined
  cardSurface?: '1' | '2' | undefined
  className?: string | undefined
  maxWidth?: string | undefined
}

export function CtaBanner({
  title,
  description,
  ctaText,
  ctaHref,
  surface = '0',
  cardSurface = '2',
  className,
  maxWidth = 'max-w-4xl',
}: CtaBannerProps) {
  return (
    <Section surface={surface} className={className}>
      <Container>
        <div
          className={cn(
            'rounded-sm border border-border p-6 sm:p-12 md:p-16 text-center mx-auto flex flex-col items-center',
            cardSurface === '1' ? 'bg-surface-1' : 'bg-surface-2',
            maxWidth
          )}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-fg text-balance">
            {title}
          </h2>
          <p className="mt-3 sm:mt-4 text-sm sm:text-base text-fg-subtle max-w-xl text-pretty leading-relaxed">
            {description}
          </p>
          <div className="mt-6 sm:mt-8 w-full sm:w-auto">
            <Link
              to={ctaHref}
              className={buttonVariants({
                variant: 'primary',
                size: 'lg',
                className: 'w-full sm:w-auto px-6 sm:px-8',
              })}
            >
              <span>{ctaText}</span>
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </Container>
    </Section>
  )
}
